import { Text } from '@/components/ui/text';
import { VStack } from '@/components/ui/vstack';

/**
 * What an empty thread says. Staff usually arrive here from New message, about
 * to write the first message, so they are told that it starts the conversation
 * and notifies the member; a member is told where support messages will appear.
 */
export function EmptyThread({
  viewerRole,
  counterpartName,
}: {
  viewerRole: 'member' | 'support';
  counterpartName: string;
}) {
  return (
    <VStack className="flex-1 items-center justify-center gap-1 px-6">
      <Text className="text-center font-semibold text-base text-typography-900">
        No messages yet
      </Text>
      <Text className="text-center text-sm text-typography-700">
        {viewerRole === 'support'
          ? `Your message starts the conversation. ${counterpartName} will be notified.`
          : 'Messages from Primum Support will appear here.'}
      </Text>
    </VStack>
  );
}
